module.exports = __webpack_public_path__ + "img/密码读卡器 (1).772467b9.jpg";